import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Result() {
  return (
    <section className="result_par p-100 text_peanut">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              The <span>Results</span>
            </h2>
            <p>
              Peanut Butter Park is a one-of-a-kind dog application that makes
              pet parenting a fun experience. It was built as per the client's
              instructions using innovative digital solutions. From maintaining
              and managing user profiles to creating alerts and joining parks,
              every feature was seamlessly integrated to keep the experience
              smooth and user-friendly. The client’s goal was to create an app
              that helps create a tight-knit and interactive community of dog
              owners in the United States. With the Peanut Butter Park app, we
              have helped them accomplish just that.
            </p>
            <div className="banner_btn">
              <Link to="https://apps.apple.com/us/app/peanut-butter-park/id1635347261">
                <StaticImage
                  src="../../../images/case-studies/amj/app_store.webp"
                  alt="TekRevol"
                  className=""
                  layout="constrained"
                  placeholder="blurred"
                  formats={["png"]}
                  width={164}
                  height={60}
                />
              </Link>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <div className="result_img">
              <StaticImage
                src="../../../images/case-studies/peanut/result_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={628}
                height={593}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Result;
